import { Component, OnInit } from '@angular/core';
import { GridviewComponent } from '../gridview/gridview.component';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss']
})
export class RequestsComponent implements OnInit {
  private gridApi;
  public addnew:Boolean = false;
  private gridColumnApi;
  public context;
  private frameworkComponents;
  public requestedValue:any;
  public transferData:any;
  status:any = 'Not Submitted';
  edit:Boolean = false;
  constructor(public toastService:ToastrService, public loginService:LoginService, public router:Router) {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    if(sessionStorage.getItem('status') != undefined && CryptoJS.AES.decrypt(sessionStorage.getItem('status'), key).toString(CryptoJS.enc.Utf8) == 'SNAP RTW/Workfare'){
      this.router.navigate(['dashboard']);
    }
   }

  ngOnInit() {
    this.context = {
      componentParent:this
    };
    this.frameworkComponents = {
      viewrenderer: GridviewComponent
    };
    if(this.loginService.requestType != null){
      this.requestedValue = 'AP';
    }
  if(this.loginService.staticData.get('requestsData') !=undefined){
    this.transferData = this.loginService.staticData.get('requestsData');
    this.status = this.transferData.status;
    this.edit = true;
    if(this.loginService.staticData.get('requestsData').type == 'Appointment request'){
      this.requestedValue = 'AP';
    }
    else{
      this.requestedValue = 'GC';
    }
  }
  }
  newRequest(){
    this.addnew = true;
  }
  keyEvent(event,value){
    if(event.keyCode == 13 || event.keyCode == 32){
      this.requestedValue = value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/requests/requests.component.ts